export function formatNumberLikeSocialMedia(number) {
  if (number < 1000) {
    return number.toString();
  } else if (number < 1_000_000) {
    return (number / 1000).toFixed(1).replace(/\.0$/, '') + 'k';
  } else if (number < 1_000_000_000) {
    return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
  } else {
    return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
  }
}

export const sortByAttribute = (arr, attribute) => {
  return arr?.sort((a, b) => {
    if (a[attribute] < b[attribute]) {
      return -1;
    }
    if (a[attribute] > b[attribute]) {
      return 1;
    }
    return 0;
  });
};

export function sortArrayAlphabetically(array) {
  return array.sort((a, b) => a.title.localeCompare(b.title));
}
